import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { StyledLink } from "../utils/button";
import { IconContext } from "react-icons";
import { MdOutlineCall } from "react-icons/md";
import { RiLinkedinFill } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";
import { IoLogoTwitter } from "react-icons/io";
import { GrLocation } from "react-icons/gr";
import { IoLogoInstagram } from "react-icons/io";

import "../styles/contact.css";

export const StyledFieldset = styled.fieldset`
  display: grid;
  gap: 1em;
  padding-top: 2em;
  grid-template-columns: 1fr;
`;

const Contact = () => {
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0.4 }}
      transition={{ duration: 0.5 }}
      className="contact"
    >
      <section>
        <IconContext.Provider value={{ className: "contact-social-icons" }}>
          <div>
            <div className="contact-form-content">
              <h2>Get in touch</h2>
              <p>
                We would love to hear from you. Our friendly <br /> team is here
                to chat.
              </p>

              <div>
                <p>
                  <span>@</span>Email Us
                </p>
                <p>
                  <a href="mailto:hello@vidom.com">hello@vidom.com</a>
                </p>
              </div>
              <div>
                <p>
                  <GrLocation className="contact-marker" /> Office
                </p>
                <p>
                  Lorem ipsum dolor sit amet, <br /> consectetur adipiscing
                  elit. Purus.
                </p>
              </div>
              <div>
                <p>
                  <MdOutlineCall /> Call
                </p>
                <p>
                  <a href="tel:+1(678)000-000">+1 (678) 000-0000</a>
                </p>
              </div>

              <div>
                <ul>
                  <li>
                    <a href="https://facebook.com">
                      <BsFacebook className="contact-social-link" />
                    </a>
                  </li>
                  <li>
                    <a href="https://instagram.com">
                      <IoLogoInstagram className="custom-contact-links" />
                    </a>
                  </li>
                  <li>
                    {" "}
                    <a href="https://linkedin.com">
                      <RiLinkedinFill className="custom-contact-links" />
                    </a>
                  </li>
                  <li>
                    <a href="https://twitter.com">
                      <IoLogoTwitter className="custom-contact-links" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="contact-form-container">
              <form>
                <h2>Tell us how we can help</h2>
                <StyledFieldset>
                  <input
                    type="text"
                    placeholder="Your name"
                    required
                  />
                  <input
                    type="email"
                    placeholder="Your email"
                    required
                  />
                  <textarea
                    placeholder="Type your message"
                    required
                    rows={5}
                    cols={52}
                  ></textarea>
                  <StyledLink
                    as="button"
                    type="submit"
                  >
                    Send Message
                  </StyledLink>
                </StyledFieldset>
              </form>
            </div>
          </div>
        </IconContext.Provider>
      </section>
    </motion.main>
  );
};

export default Contact;
